/**
 * <app-shell> — layout, header, nav, footer, the standing disclaimer and the
 * skip link. Owns nothing but structure.
 *
 * © Manish Jagdish Thatte
 */

import { subscribe } from '../store.js';

export class AppShell extends HTMLElement {
  connectedCallback() {
    if (this._built) return;
    this._built = true;

    const header = document.createElement('header');
    header.className = 'site-header';

    const brand = document.createElement('a');
    brand.className = 'site-brand';
    brand.href = '#/';
    const deva = document.createElement('span');
    deva.className = 'site-brand__deva';
    deva.lang = 'sa';
    deva.setAttribute('translate', 'no');
    deva.textContent = 'शास्त्र';
    const latin = document.createElement('span');
    latin.className = 'site-brand__latin';
    latin.textContent = 'shastra.site';
    brand.append(deva, latin);

    const nav = document.createElement('site-nav');
    const tools = document.createElement('div');
    tools.className = 'site-tools';
    tools.append(document.createElement('locale-switcher'),
                 document.createElement('theme-toggle'));

    header.append(brand, nav, tools);

    this._status = document.createElement('div');
    this._status.className = 'site-status';
    this._status.setAttribute('role', 'status');
    this._status.setAttribute('aria-live', 'polite');

    const footer = document.createElement('footer');
    footer.className = 'site-footer';
    footer.append(document.createElement('disclaimer-note'));

    const credits = document.createElement('p');
    credits.className = 'site-credits';
    credits.append(
      document.createTextNode('© Manish Jagdish Thatte. Place data from '),
      link('https://www.geonames.org/', 'GeoNames'),
      document.createTextNode(' (CC BY 4.0). Positions computed with '),
      link('https://github.com/cosinekitty/astronomy', 'astronomy-engine'),
      document.createTextNode('.')
    );
    footer.append(credits);

    this.prepend(header);
    this.insertBefore(this._status, this.querySelector('#main'));
    this.append(footer);

    this._unsubscribe = subscribe('status', (s) => this.showStatus(s));
  }

  disconnectedCallback() {
    this._unsubscribe?.();
  }

  showStatus(status) {
    this._status.textContent = status?.message ?? '';
    this._status.dataset.severity = status?.severity ?? '';
  }
}

function link(href, text) {
  const a = document.createElement('a');
  a.href = href;
  a.textContent = text;
  a.rel = 'noopener';
  return a;
}

customElements.define('app-shell', AppShell);
